import { Input, Directive } from '@angular/core';
import { IPhxDateEvent, IDatesTooltip } from './utils/types';
import mixinDisabled from '../../mixins/disabled';

const _PhxDatePickerMixinBase = mixinDisabled(
  class {
    constructor() {}
  }
);

@Directive()
export abstract class PhxDatePickerBase extends _PhxDatePickerMixinBase {
  @Input() public phxPlaceholder: string;
  @Input() public phxMinSelectableDate: Date;
  @Input() public phxMaxSelectableDate: Date;
  @Input() public phxEnabledDates: Date[];
  @Input() public phxEvents: IPhxDateEvent[];
  @Input() public phxDatesTooltip: IDatesTooltip[];
  @Input() public phxHasError: boolean = false;

  constructor() {
    super();
  }
}
